import * as React from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
// import { REACT_APP_BUS_SITE } from '../constants/StoreSetting';
import {env} from '../env'

const {REACT_APP_BUS_SITE} = env

export default class NavMenu extends React.PureComponent<{}, { isOpen: boolean }> {
    public state = {
        isOpen: false
    };

    public render() {
        return (
            <header className="grey-header">
                <Navbar className="navbar-expand-sm navbar-toggleable-sm box-shadow  small-navbar" light>
                    <Container fluid={true} className='plr'>
                        <ul className="navbar-nav flex-grow">
                        {/* <li className="nav-item hidden-sm">
                            <a className="nav-link">Talk to a Retail Specialist   </a>
                        </li>
                        <li className="nav-item"><a className="text-dark nav-link item-margin" href="/counter">+1-844-814-5409</a>
                        </li> */}
                        </ul>
                        <ul className="navbar-nav flex-grow in-row started-nav">
                            <NavItem>
                                <NavLink tag={Link} className="text-dark item-margin" to="/SignIn">Sign In</NavLink>
                                </NavItem>
                                <NavItem>
                                {/* <NavLink tag={Link} className="text-dark item-margin" to="https://www.dakarsoftware.com/contact-us/">Help</NavLink> */}
                                </NavItem>
                                <NavItem>
                                <NavLink tag={Link} className="text-dark item-margin" onClick={()=>{window.location.replace(REACT_APP_BUS_SITE)}}   >Home</NavLink>
                                </NavItem>
                            </ul>
                     
                    </Container>
                </Navbar>
            </header>
        );
    }

    private toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
}
